export default function ConfigurationTabs({ tabs, activeTab, setActiveTab }) {
  return (
    <div className="border-b border-gray-200 px-6">
      <div className="flex gap-1 pt-1">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={`px-8 py-2 font-medium text-sm transition-colors rounded-t-lg ${
              activeTab === tab.id
                ? "bg-white text-gray-900 border-t border-x border-gray-200"
                : "bg-gray-100 text-gray-600 hover:text-gray-900 hover:bg-gray-200 cursor-pointer"
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>
    </div>
  );
}
